import { sessaoFetch, sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/contrato/${id}`)
}
export async function getContratos (dados) {
  return sessaoFetchLoading(`base`, `/contrato?` + serialize(dados), 'GET')
}
export async function contratosSelect () {
  return sessaoFetchLoading(`base`, `/contrato?all=1`)
}
export async function add (dados) {
  return sessaoFetchLoading(`base`, `/contrato`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/contrato/${dados.id}`, 'PUT', dados)
}
export async function del (dados) {
  let retorno = await sessaoFetchLoading(`base`, `/contrato/${dados}`, 'DELETE')
  return retorno
}
export async function listByProdutoInstituicao (parametros) {
  let query = '?all=1'
  if (parametros.instituicao) query += `&instituicao_id=${parametros.instituicao}`
  if (parametros.produto) query += `&produto_id=${parametros.produto}`
  return sessaoFetch(`base`, `/contrato${query}`, 'GET')
}



// WEBPACK FOOTER //
// ./src/api/contrato.js